/** @jsx isolateComponent */

import { useQuery, useMutation } from '@apollo/react-hooks';
import { useRouter } from 'next/router';

import { isolateComponent } from '@zapier/common-utils';
import { useTrackingContext } from '@zapier/toolbox-tracking';
import { UniversalLayout } from '@zapier/universal-layout';

type UniversalLayoutProps = React.ComponentProps<typeof UniversalLayout>;
type Props = Pick<
  Partial<UniversalLayoutProps>,
  | 'children'
  | 'mainContentId'
  | 'renderFooter'
  | 'renderHeader'
  | 'renderNotifications'
  | 'shouldRenderAlphabetNav'
  | 'shouldRenderSeoLinks'
>;

export const SsrUniversalLayout = (props: Props) => {
  const currentUrl = useRouter()?.pathname || '';
  const { trackEvent } = useTrackingContext();

  return (
    <UniversalLayout
      currentUrl={currentUrl}
      mainContentId={props.mainContentId}
      renderFooter={props.renderFooter}
      renderHeader={props.renderHeader}
      renderNotifications={props.renderNotifications}
      shouldRenderAlphabetNav={props.shouldRenderAlphabetNav}
      shouldRenderSeoLinks={props.shouldRenderSeoLinks}
      trackEvent={trackEvent}
      useMutation={useMutation}
      useQuery={useQuery}
    >
      {props.children}
    </UniversalLayout>
  );
};
